import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { IconChevronLeftSolidFull } from "../../../icon";

function BackButton() {
  const navigate = useNavigate();

  return <Button icon={<IconChevronLeftSolidFull />}  type="primary" onClick={() => navigate(-1)} style={{ marginBottom: '24px' }}>Zurück</Button>
}

export default BackButton;